/**
 * @graph-stack product-innovation-lab
 * @graph-domain UX
 * @graph-business KPIテーブル用スケルトン。モバイルはカードビュー、デスクトップはテーブルビューの2パターンでローディング状態を表示
 * @graph-connects none
 */
import { Card, CardHeader, CardContent } from '@cortex/web-design-system/components/ui/Card';
import { Skeleton } from '@cortex/web-design-system/components/ui/Skeleton';

/** @graph-connects none */
export function KpiTableSkeleton() {
  return (
    <Card>
      <CardHeader>
        <Skeleton variant="text" width="100px" height="1.25rem" />
      </CardHeader>
      <CardContent>
        {/* モバイル: カードビュー */}
        <div className="block md:hidden space-y-3">
          {[1, 2, 3].map((i) => (
            <div key={i} className="p-4 rounded-lg border border-[var(--color-border)]">
              <div className="flex items-center justify-between mb-3">
                <Skeleton variant="text" width="60px" height="1rem" />
                <Skeleton variant="text" width="50px" height="1.5rem" />
              </div>
              <div className="grid grid-cols-2 gap-3">
                {[1, 2, 3, 4].map((j) => (
                  <div key={j}>
                    <Skeleton variant="text" width="60%" height="0.75rem" />
                    <Skeleton variant="text" width="40%" height="1rem" className="mt-1" />
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* デスクトップ: テーブルビュー */}
        <div className="hidden md:block">
          <table className="w-full">
            <thead>
              <tr className="border-b border-[var(--color-border)]">
                {[1, 2, 3, 4, 5, 6].map((h) => (
                  <th key={h} className="py-3 px-4 text-left">
                    <Skeleton variant="text" width="80px" height="0.875rem" />
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {[1, 2, 3].map((i) => (
                <tr key={i} className="border-b border-[var(--color-border)]">
                  {[1, 2, 3, 4, 5, 6].map((j) => (
                    <td key={j} className="py-3 px-4">
                      <Skeleton variant="text" width={j === 1 ? '60px' : '40px'} height="1rem" />
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </CardContent>
    </Card>
  );
}
